module.exports = __webpack_public_path__ + "img/94.c6e9d72b.png";